import React from 'react';
import _ from 'lodash';
import { Grid, TextField, Select, MenuItem, InputLabel, FormControl } from "@material-ui/core";
import { changeDestination, changeFlightNumber, changeOrigin, changePassenger, changeRloc, changeTailNumber, changeStatus } from "../../../store/dcs";
import { useDispatch, useSelector } from "react-redux";
// import { SelectWithLabel } from "../../../utils/selectWithLabel";
import styles from "../styles";

const Filters = (props) => {
  const dispatch = useDispatch();
  const departures = useSelector(state => state.entities.dcs.list);
  const rlocFilter = useSelector(state => state.entities.dcs.rloc);
  const paxFilter = useSelector(state => state.entities.dcs.passenger);
  const originFilter = useSelector(state => state.entities.dcs.origin)
  const destFilter = useSelector(state => state.entities.dcs.destination)
  const flightFilter = useSelector(state => state.entities.dcs.flightNumber)
  const tailFilter = useSelector(state => state.entities.dcs.tailNumber)
  const statusFilter = useSelector(state => state.entities.dcs.status)
  // console.log(statusFilter)
  const {theme, isMobile} = props;
  const classes = styles(theme, isMobile);

  const removeDupes = (arr, val) => {
    let output = _.uniqBy(arr, val);
    output = _.sortBy(output, val)
    return output
  }

  let depChoices = ['None'].concat(removeDupes(departures, 'Origin').map((item) => item['Origin']))
  let arrChoices = ['None'].concat(removeDupes(departures, 'Destination').map((item) => item['Destination']))
  let flightChoices = ['None'].concat(removeDupes(departures, 'FlightNumber').map((item) => item['FlightNumber']))
  let tailChoices = ['None'].concat(removeDupes(departures, 'TailNumber').map((item) => item['TailNumber']))
  const statusChoices = ['Active', 'Cancelled']

  function handleChange(event) {
    let filterVal = event.target.value
    let filterName = event.target.name
    if (filterVal === 'None' || !filterVal) {
      filterVal = ''
    }

    switch (filterName) {
      case 'origin':
        dispatch(changeOrigin(filterVal));
        break;
      case 'destination':
        dispatch(changeDestination(filterVal));
        break;
      case 'flightNumber':
        dispatch(changeFlightNumber(filterVal));
        break;
      case 'tailNumber':
        dispatch(changeTailNumber(filterVal));
        break;
      case 'passenger':
        dispatch(changePassenger(filterVal));
        break;
      case 'rloc':
        dispatch(changeRloc(filterVal));
        break;
      case 'status':
        dispatch(changeStatus(filterVal));
        break;
    }
  }

  return (
    <Grid container>
      <Grid justifyContent="center" item xs={12} lg={2}>
        <FormControl>
          <InputLabel id="origin-dcs-select-label">Origin</InputLabel>
          <Select
            name="origin"
            id="origin-dcs-select"
            labelId="origin-dcs-select-label"
            onChange={handleChange}
            className={classes.selectInput}
            value={originFilter}
          >
            {depChoices.map((choice) => {
              return <MenuItem value={choice}>{choice}</MenuItem>
            })}
          </Select>
        </FormControl>
      </Grid>
      <Grid justifyContent="center" item xs={12} lg={2}>
        <FormControl>
          <InputLabel id="destination-dcs-select-label">Destination</InputLabel>
          <Select
            name="destination"
            id="destination-dcs-select"
            labelId="destination-dcs-select-label"
            onChange={handleChange}
            className={classes.selectInput}
            value={destFilter}
          >
            {arrChoices.map((choice) => {
              return <MenuItem value={choice}>{choice}</MenuItem>
            })}
          </Select>
        </FormControl>
      </Grid>
      <Grid justifyContent="center" item xs={12} lg={2}>
        <FormControl>
          <InputLabel id="flightNumber-dcs-select-label">Flight Number</InputLabel>
          <Select
            name="flightNumber"
            id="flight-number-dcs-select"
            labelId="flight-number-dcs-select-label"
            onChange={handleChange}
            className={classes.selectInput}
            value={flightFilter}
          >
            {flightChoices.map((choice) => {
              return <MenuItem value={choice}>{choice}</MenuItem>
            })}
          </Select>
        </FormControl>
      </Grid>
      <Grid justifyContent="center" item xs={12} lg={2}>
        <FormControl>
          <InputLabel id="tail-number-dcs-select-label">Tail Number</InputLabel>
          <Select
            name="tailNumber"
            id="tail-number-dcs-select"
            labelId="tail-number-dcs-select-label"
            onChange={handleChange}
            className={classes.selectInput}
            value={tailFilter}
          >
            {tailChoices.map((choice) => {
              return <MenuItem value={choice}>{choice}</MenuItem>
            })}
          </Select>
        </FormControl>
      </Grid>
      <Grid justifyContent="center" item xs={12} lg={2} style={{ marginTop: "5px" }}>
        <TextField
          id="rloc"
          label="RLOC"
          defaultValue={rlocFilter}
          className={classes.indexTextField}
          InputLabelProps={{ shrink: true }}
          onChange={handleChange}
          name="rloc"
        />
      </Grid>
      <Grid justifyContent="center" item xs={12} lg={2} style={{ marginTop: "5px" }}>
        <TextField
          id="pax-name"
          label="Pax Name"
          defaultValue={paxFilter}
          className={classes.indexTextField}
          InputLabelProps={{ shrink: true }}
          onChange={handleChange}
          name="passenger"
        />
      </Grid>
      <Grid justifyContent="center" item xs={12} lg={2}>
        <FormControl>
          <InputLabel id="status-dcs-select-label">Flight Status</InputLabel>
          <Select
            name="status"
            id="status-dcs-select"
            labelId="status-dcs-select-label"
            onChange={handleChange}
            className={classes.selectInput}
            value={statusFilter}
          >
            {statusChoices.map((choice) => {
              return <MenuItem value={choice}>{choice}</MenuItem>
            })}
          </Select>
        </FormControl>
      </Grid>
    </Grid>
  );
};

export default Filters;